import AssetsSection from './AssetsSection';
import GeospatialLayersSection from './GeospatialLayersSection';
import UsersSection from './UsersSection';
import WorkSection from './WorkSection';

import classes from './filterPanel.module.css';

const FilterPanel = () => (
  <div className={classes.container}>
    <div className={classes.mainHeader}>Map Layers</div>
    <div className={classes.sectionList}>
      <AssetsSection />
      <WorkSection />
      <UsersSection />
      <GeospatialLayersSection />
      <div className={classes.containerFooter} />
    </div>
  </div>
);

export default FilterPanel;
